import { render, staticRenderFns } from "./CdbCustomerLogs.vue?vue&type=template&id=50ead79e&scoped=true&"
import script from "./CdbCustomerLogs.vue?vue&type=script&lang=js&"
export * from "./CdbCustomerLogs.vue?vue&type=script&lang=js&"
import style0 from "./CdbCustomerLogs.vue?vue&type=style&index=0&id=50ead79e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ead79e",
  null
  
)

export default component.exports